var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isInRole(["manual_subs"])
    ? _c(
        "div",
        [
          _c("toolbar"),
          _vm._v(" "),
          _c("zlick-navigation"),
          _vm._v(" "),
          _c(
            "v-container",
            { attrs: { fluid: "", "text-xs-center": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", center: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", "offset-xs0": "" } },
                    [
                      _c("v-stepper", [
                        _c(
                          "div",
                          { staticClass: "v-stepper__content" },
                          [
                            _c(
                              "v-form",
                              {
                                ref: "addsub",
                                attrs: { "lazy-validation": "" },
                                model: {
                                  value: _vm.valid,
                                  callback: function($$v) {
                                    _vm.valid = $$v
                                  },
                                  expression: "valid"
                                }
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    "validate-on-blur": "",
                                    rules: [
                                      function(v) {
                                        return !!v || _vm.$t("email_required")
                                      }
                                    ],
                                    label: _vm.$t("email"),
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.subscriptionData.email,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.subscriptionData,
                                        "email",
                                        $$v
                                      )
                                    },
                                    expression: "subscriptionData.email"
                                  }
                                }),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: { label: _vm.$t("phone_number") },
                                  model: {
                                    value: _vm.subscriptionData.phone,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.subscriptionData,
                                        "phone",
                                        $$v
                                      )
                                    },
                                    expression: "subscriptionData.phone"
                                  }
                                }),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: { label: _vm.$t("clientUserId") },
                                  model: {
                                    value: _vm.subscriptionData.clientUserId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.subscriptionData,
                                        "clientUserId",
                                        $$v
                                      )
                                    },
                                    expression: "subscriptionData.clientUserId"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      "close-on-content-click": false,
                                      "nudge-right": 40,
                                      transition: "scale-transition",
                                      "offset-y": "",
                                      "min-width": "290px"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "v-text-field",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "subscriptionExpiresAt"
                                                        ),
                                                        "prepend-icon": "event",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.subscriptionData
                                                            .subscriptionExpiresAt,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.subscriptionData,
                                                            "subscriptionExpiresAt",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "subscriptionData.subscriptionExpiresAt"
                                                      }
                                                    },
                                                    "v-text-field",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                )
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2252757565
                                    ),
                                    model: {
                                      value: _vm.datePickerShow,
                                      callback: function($$v) {
                                        _vm.datePickerShow = $$v
                                      },
                                      expression: "datePickerShow"
                                    }
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("v-date-picker", {
                                      on: {
                                        input: function($event) {
                                          _vm.datePickerShow = false
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.subscriptionData
                                            .subscriptionExpiresAt,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.subscriptionData,
                                            "subscriptionExpiresAt",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "subscriptionData.subscriptionExpiresAt"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    "validate-on-blur": "",
                                    rules: [
                                      function(v) {
                                        return !!v || _vm.$t("product_required")
                                      }
                                    ],
                                    label: _vm.$t("product"),
                                    items: _vm.products,
                                    "item-text": "name",
                                    "return-object": true,
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.subscriptionData.selectedProduct,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.subscriptionData,
                                        "selectedProduct",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "subscriptionData.selectedProduct"
                                  }
                                }),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    "validate-on-blur": "",
                                    rules: [
                                      function(v) {
                                        return (
                                          !!v || _vm.$t("payment_type_required")
                                        )
                                      }
                                    ],
                                    label: _vm.$t("paymentType"),
                                    items: _vm.paymentTypes,
                                    "item-text": "name",
                                    "return-object": true,
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.subscriptionData.paymentType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.subscriptionData,
                                        "paymentType",
                                        $$v
                                      )
                                    },
                                    expression: "subscriptionData.paymentType"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { disabled: !_vm.valid },
                                    on: { click: _vm.addSubscriber }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("submit")))]
                                ),
                                _vm._v(" "),
                                _c("v-btn", { on: { click: _vm.clear } }, [
                                  _vm._v(_vm._s(_vm.$t("cancel")))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-snackbar",
            {
              attrs: {
                timeout: _vm.snackbar.timeout,
                color: _vm.snackbar.color,
                "multi-line": _vm.snackbar.multiline
              },
              model: {
                value: _vm.snackbar.show,
                callback: function($$v) {
                  _vm.$set(_vm.snackbar, "show", $$v)
                },
                expression: "snackbar.show"
              }
            },
            [
              _vm._v("\n    " + _vm._s(_vm.snackbar.text) + "\n    "),
              _c(
                "v-btn",
                {
                  attrs: { color: "white", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.snackbar.show = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("close")))]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3f5192e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3f5192e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddSubscriber.vue
// module id = null
// module chunks = 